import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Actions from 'actions';
import { IncidentFormNew } from './';
import { Modal, Panel } from 'react-bootstrap';

class IncidentCreateModal extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <Modal bsSize='lg' show={this.props.show_create_incident} onHide={this.props.hideCreateIncident}>
      <Panel bsStyle="primary" className="mb-none" header={<h3 className="title">Create New Damage Incident</h3>}>
          <IncidentFormNew editing new />
      </Panel>
    </Modal>
  }
}

const mapStateToProps = ({ client_incidents }) => ({...client_incidents});

export default connect(mapStateToProps, Actions)(IncidentCreateModal);



// WEBPACK FOOTER //
// ./src/browser/components/client/incidents/incident-create-modal.js